import React, { useEffect, useState } from 'react'
import './countdown.css'
import pictureOne from './1.jpg'
import pictureTwo from './2.jpg'
import pictureThree from './3.jpg'
import pictureFour from './4.jpg'
import pictureFive from './5.jpg'
import pictureSix from './6.jpg'
import pictureSeven from './7.jpg'
import pictureEight from './8.jpg'
import pictureNine from './9.jpg'
import pictureTen from './10.jpg'
import pictureEleven from './11.jpg'
import pictureElevenFive from './11_5.jpg'
import pictureTwelve from './12.jpg'
import pictureThirteen from './13.jpg'
import pictureFourteen from './14.jpg'
import pictureFifteen from './15.jpg'
import pictureSixteen from './16.jpg'
import pictureSeventeen from './17.jpg'

export default function CountdownEntry({pictureDescriptionParam, imageSourceParam, colorDescriptionParam, backgroundColor, textColor, borderTop, specialEffect, index, isPast}) {
  const [pictureDescription, setPictureDescription] = useState(pictureDescriptionParam)
  const [colorDescription, setColorDescription] = useState(colorDescriptionParam)
  const [imageSource, setImageSource] = useState(imageSourceParam)

  useEffect(() => {
    if(index == 0 && isPast == false){
      document.getElementById('countdown-container-' + index).style.paddingTop = '100px'
    }
    if(index == 100 && isPast == true){
      document.getElementById('countdown-container-' + index).style.paddingTop = '100px'
    }
    const countdownContainerElement = document.getElementById('countdown-container-' + index)
    document.getElementById('countdown-container-' + index).style.backgroundColor = backgroundColor
    countdownContainerElement.style.color = textColor
    countdownContainerElement.classList.add(specialEffect)
  }, [])

  return (
    <div id={"countdown-container-" + index} className={"countdown-container-" + index}>
      <div className='countdown-picture-container'>
        <div className='entry-countdown-picture-description'>
            {pictureDescription}
          </div>
        <div className='countdown-picture-wrapper'>
          <img
            className="countdown-picture"
            src={imageSource}
          />
        </div>
      </div>
      
        <div className='entry-countdown-color-description-container'>
          <div className='entry-countdown-color-description'>
            {colorDescription}
          </div>
        </div>
    </div>
  )
}
